import { Injectable } from '@angular/core';
import { DataLoaderService } from './data-loader.service';
import { PriceCalculationService } from './price-calculation.service';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { CommonDataService } from './common-data.service';

@Injectable()
export class ProgressBarService {
  private subscription: Subscription;
  private color; additionalColor; upholstery;

  constructor(private dataLoaderService: DataLoaderService,
    private priceCalculationService: PriceCalculationService,private commonDataService: CommonDataService) { }

  /**
   * To display red light in the progress bar
   * @param none
   * @returns none
   */
  private notifyRed = new Subject<any>();
  notifyObservableRed$ = this.notifyRed.asObservable();
  illuminateRed() {
    this.notifyRed.next();
  }
  /**
   * To display yellow light in the progress bar
   * @param none
   * @returns none
   */
  private notifyYellow = new Subject<any>();
  notifyObservableYellow$ = this.notifyYellow.asObservable();
  illuminateYellow() {
    this.notifyYellow.next();
  }
  /**
   * To display green light in the progress bar
   * @param none
   * @returns none
   */
  private notifyGreen = new Subject<any>();
  notifyObservableGreen$ = this.notifyGreen.asObservable();
  illuminateGreen() {
    this.notifyGreen.next();
  }

  progressBarValidation() {
    this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
      if (selectedOption.fromComponent == "normalColor" || selectedOption.fromComponent == "expertColor") {
        this.color = selectedOption.data[0];
      } else if (selectedOption.fromComponent == "normalAddColor" || selectedOption.fromComponent == "expertAddColor") {
        this.additionalColor = selectedOption.data[0];
      } else if (selectedOption.fromComponent == "normalUpholstery" || selectedOption.fromComponent == "expertUpholstery") {
        this.upholstery = selectedOption.data[0];
      }
      
    });
    
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' && this.dataLoaderService.data.additionalColor.length > 0) {
      if ((this.color != undefined) && (this.additionalColor != undefined) && (this.upholstery != undefined)) {
        if(this.dataLoaderService.flagDictionary.validated == true){
          this.illuminateGreen();
        }
      } 
      else {
        this.illuminateRed();
      }
    } else {
      if ((this.color != undefined) && (this.upholstery != undefined)) {
            if(this.color.selected == true && this.upholstery.selected == true && this.dataLoaderService.flagDictionary.validated == true){
              this.illuminateGreen();
            }
            else {
              this.illuminateRed();
            }
          }
      else {
        this.illuminateRed();
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/progress-bar.service.ts